import { OptionSelect } from './../../../../../../../shared/select/select.component';
import { LoaderService } from './../../../../../../../shared/loader/loader.service';
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalComponent } from '../../../../../../../shared/modal/modal.component';
import { ButtonComponent } from '../../../../../../../shared/button/button.component';
import { DividerComponent } from '../../../../../../../shared/divider/divider.component';
import { InputIconComponent } from '../../../../../../../shared/input-icon/input-icon.component';
import { CheckboxComponent } from '../../../../../../../shared/checkbox/checkbox.component';
import { ToggleComponent } from '../../../../../../../shared/toggle/toggle.component';
import { TextareaComponent } from '../../../../../../../shared/textarea/textarea.component';
import { SelectComponent } from '../../../../../../../shared/select/select.component';
import { ChipsSelectsComponent } from '../../../../../../../shared/chips-selects/chips-selects.component';
import { ModalService } from '../../../../../../../shared/modal/modal.service';
import { SelectColorComponent } from '../../../../../../../shared/select-color/select-color.component';
import { UserService } from '../../../../../../../shared/services/user/user.service';
import { User } from '../../../../../../../models/authentication.interface';
import {
  AgendaRequest,
  EnviarPara,
  Agenda,
} from '../../../../../../../models/agenda.interface';
import { Post, toPost } from '../../../../../../../models/rest.interface';
import { AgendaService } from '../../agenda.service';
import { ToastService } from '../../../../../../../shared/toast/toast.service';
import { TurmasService } from '../../../../turmas/turmas.service';
import {
  Tab,
  TabsComponent,
} from '../../../../../../../shared/tabs/tabs.component';
import { steps } from '../../../../../../../shared/stepper/stepper.component';
import { escolaBehavior } from '../../../../../../../models/escola.interface';

@Component({
  selector: 'app-editar-evento',
  standalone: true,
  imports: [
    ModalComponent,
    ButtonComponent,
    DividerComponent,
    InputIconComponent,
    CheckboxComponent,
    ToggleComponent,
    TextareaComponent,
    SelectComponent,
    ChipsSelectsComponent,
    SelectColorComponent,
    TabsComponent,
  ],
  templateUrl: './editar-evento.component.html',
  styleUrl: './editar-evento.component.scss',
})
export class EditarEventoComponent implements OnInit {
  @Input() data!: Agenda;

  files: File[] = [];
  tabSelected: string = 'evento';
  chips: any[] = [];
  campoObrigatorio: boolean = false;
  diaInteiro: boolean = false;
  todasTurmas: boolean = false;
  optionTurmas: OptionSelect[] = [];
  enviarParaSelected!: OptionSelect;
  categoriaSelected!: OptionSelect;
  idsTurmas: OptionSelect[] = [];
  uploadedFiles: any[] = [];

  form = new FormGroup({
    enviarPara: new FormControl('', Validators.required),
    data: new FormControl('', Validators.required),
    diaInteiro: new FormControl(false),
    assunto: new FormControl('', Validators.required),
    descricao: new FormControl('', Validators.required),
    horaInicio: new FormControl(''),
    horaFim: new FormControl(''),
    dataLembrete: new FormControl('', Validators.required),
    color: new FormControl('sem_cor', Validators.required),
    escola: new FormControl<number | null>(null, Validators.required),
    categoria: new FormControl('', Validators.required),
    idsTurmas: new FormControl<number[]>([]),
    arquivo: new FormControl<any[]>([]),
    enviarTodasTurmas: new FormControl(false),
  });

  steps: Tab[] = [
    {
      label: 'Evento',
      value: 'evento',
      selected: true,
      icon: '',
    },
    {
      label: 'Arquivo',
      value: 'arquivo',
      selected: false,
      icon: '',
    },
  ];

  constructor(
    private readonly modalService: ModalService,
    private readonly userSercice: UserService,
    private readonly agendaService: AgendaService,
    private readonly toast: ToastService,
    private readonly loaderService: LoaderService,
    private readonly turmasService: TurmasService,
  ) {}

  ngOnInit(): void {
    if(this.userSercice.escolaSelecionada !== undefined) {
      this.form.controls.escola.setValue(this.userSercice.escolaSelecionada.id);
    } else {
      console.warn('Escola não selecionada!');
    }

    // Preencher formulário com dados existentes
    if (this.data) {
      this.form.patchValue({
        enviarPara: this.data.enviarPara,
        data: this.data.data,
        diaInteiro: this.data.diaInteiro,
        assunto: this.data.assunto,
        descricao: this.data.descricao,
        horaInicio: this.data.horaInicio,
        horaFim: this.data.horaFim,
        dataLembrete: this.data.dataLembrete,
        color: this.data.color || 'sem_cor',
        escola: typeof this.data.escola === 'object' && this.data.escola ? (this.data.escola as any).id : this.data.escola,
        categoria: this.data.categoria,
        idsTurmas: this.data.idsTurmas || [],
        enviarTodasTurmas: this.data.enviarTodasTurmas,
      });

      // Configurar seleções
      this.enviarParaSelected = this.optionsPerfis.find(opt => opt.value === this.data.enviarPara) || this.optionsPerfis[0];
      this.categoriaSelected = this.optionsCategoria.find(opt => opt.value === this.data.categoria) || this.optionsCategoria[0];
      this.diaInteiro = this.data.diaInteiro;
      this.todasTurmas = this.data.enviarTodasTurmas;

      // Configurar turmas selecionadas
      if (this.data.idsTurmas && this.data.idsTurmas.length > 0) {
        this.idsTurmas = this.data.idsTurmas.map((id: any) => {
          const turma = this.optionTurmas.find(opt => opt.value === id);
          return turma || { label: `Turma ${id}`, value: id };
        });
      }

      // Configurar arquivos existentes
      if (this.data.arquivo && Array.isArray(this.data.arquivo)) {
        this.uploadedFiles = this.data.arquivo;
      }
    }

    this.loaderService
      .executeWithLoader(
        this.turmasService.listarPorEscolas({ page: 1, pageSize: 10000 }),
      )
      .subscribe({
        next: (value) => {
          this.optionTurmas = value.data.map((opt: any) => {
            return { label: opt.nome, value: opt.id };
          });

          // Reconfigurar turmas selecionadas após carregar as opções
          if (this.data?.idsTurmas && this.data.idsTurmas.length > 0) {
            this.idsTurmas = this.data.idsTurmas.map((id: any) => {
              const turma = this.optionTurmas.find(opt => opt.value === id);
              return turma || { label: `Turma ${id}`, value: id };
            });
          }
        },
        error: (err) => {
          this.toast.notify({
            message: 'Erro ao listar Turmas.',
            type: 'ERROR',
          });
        },
      });
  }

  removerArquivo(index: number) {
    this.files.splice(index, 1);
    this.uploadedFiles.splice(index, 1);
    this.form.controls.arquivo.setValue(this.uploadedFiles);
  }

  salvarArquivo(event: any) {
    const selectedFiles = event.target.files;
    if (selectedFiles) {
      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles[i];

        // Validar tamanho do arquivo (200MB)
        if (file.size > 200 * 1024 * 1024) {
          this.toast.notify({
            message: `Arquivo ${file.name} excede o tamanho máximo de 200MB.`,
            type: 'ERROR',
          });
          continue;
        }

        // Validar tipo de arquivo
        const allowedTypes = ['image/', 'application/', 'video/', 'audio/'];
        const isValidType = allowedTypes.some(type => file.type.startsWith(type));

        if (!isValidType) {
          this.toast.notify({
            message: `Tipo de arquivo ${file.name} não é suportado.`,
            type: 'ERROR',
          });
          continue;
        }

        this.files.push(file);
      }
    }
  }

  optionsPerfis: OptionSelect[] = [
    {
      label: 'Todos',
      value: EnviarPara.TODOS,
    },
    {
      label: 'Professores',
      value: EnviarPara.PROFESSORES,
    },
    {
      label: 'Pais',
      value: EnviarPara.PAIS,
    },
    {
      label: 'Coordenadores',
      value: EnviarPara.COORDENADORES,
    },
    {
      label: 'Diretoria',
      value: EnviarPara.DIRETORIA,
    },
  ];

  optionsCategoria: OptionSelect[] = [
    {
      label: 'Comunicados',
      value: 'Comunicados',
    },
    {
      label: 'Atividades Acadêmicas',
      value: 'Atividades Acadêmicas',
    },
    {
      label: 'Evento Especial',
      value: 'Evento Especial',
    },
    {
      label: 'Reunião',
      value: 'Reunião',
    },
    {
      label: 'Feriado',
      value: 'Feriado',
    },
    {
      label: 'Outros',
      value: 'Outros',
    },
  ];

  changeTabs(event: any) {
    this.tabSelected = event;
  }

  removerTurma(idTurma: number) {
    this.idsTurmas.splice(idTurma, 1);
    this.form.controls.idsTurmas.setValue(this.idsTurmas.map(t => t.value));
  }

  async agendar() {
    this.campoObrigatorio = true;

    if (this.form.invalid) {
      this.toast.notify({
        message: 'Por favor, preencha todos os campos obrigatórios.',
        type: 'ERROR',
      });
      return;
    }

    if (!this.validateTimeRange()) {
      return;
    }

    if (!this.validateTurmas()) {
      return;
    }

    try {
      this.loaderService.show();

      // Upload de arquivos se houver novos
      if (this.files.length > 0) {
        await this.uploadFiles();
      }

      const formData = this.prepareFormData();

      this.agendaService.atualizar(this.data.id.toString(), formData).subscribe({
        next: (response) => {
          this.toast.notify({
            message: 'Agenda atualizada com sucesso!',
            type: 'SUCCESS',
          });
          this.agendaService.cadastroCompleto.emit();
          this.modalService.close();
        },
        error: (error) => {
          this.toast.notify({
            message: error.message || 'Erro ao atualizar agenda.',
            type: 'ERROR',
          });
        },
        complete: () => {
          // Loader será escondido automaticamente pelo executeWithLoader
        }
      });

    } catch (error) {
      // Loader será escondido automaticamente pelo executeWithLoader
      this.toast.notify({
        message: 'Erro ao processar arquivos.',
        type: 'ERROR',
      });
    }
  }

  private async uploadFiles(): Promise<void> {
    for (const file of this.files) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('entityId', this.data.id.toString());
      formData.append('contentType', 'agenda');
      formData.append('field', 'files');

      try {
        const response = await this.agendaService.salvarArquivoAgenda(formData).toPromise();
        this.uploadedFiles.push(response);
      } catch (error) {
        this.toast.notify({
          message: `Erro ao fazer upload do arquivo ${file.name}`,
          type: 'ERROR',
        });
        throw error;
      }
    }
  }

  private prepareFormData(): any {
    const formValue = this.form.value;

    return {
      assunto: formValue.assunto,
      descricao: formValue.descricao,
      data: formValue.data,
      dataLembrete: formValue.dataLembrete,
      diaInteiro: formValue.diaInteiro,
      horaInicio: formValue.diaInteiro ? null : formValue.horaInicio,
      horaFim: formValue.diaInteiro ? null : formValue.horaFim,
      color: formValue.color,
      categoria: formValue.categoria,
      enviarPara: formValue.enviarPara,
      enviarTodasTurmas: formValue.enviarTodasTurmas,
      idsTurmas: formValue.enviarTodasTurmas ? [] : formValue.idsTurmas,
      escola: formValue.escola,
      arquivo: this.uploadedFiles.map(file => file.id),
    };
  }

  changeTurmaOption(event: any) {
    if (event && !this.idsTurmas.find(t => t.value === event.value)) {
      this.idsTurmas.push(event);
      this.form.controls.idsTurmas.setValue(this.idsTurmas.map(t => t.value));
    }
  }

  change(allDay: boolean) {
    this.diaInteiro = allDay;
    this.form.controls.diaInteiro.setValue(allDay);

    if (allDay) {
      this.form.controls.horaInicio.setValue('');
      this.form.controls.horaFim.setValue('');
    }
  }

  changeTurmas(todasTurmas: boolean) {
    this.todasTurmas = todasTurmas;
    this.form.controls.enviarTodasTurmas.setValue(todasTurmas);

    if (todasTurmas) {
      this.idsTurmas = [];
      this.form.controls.idsTurmas.setValue([]);
    }
  }

  cancelar() {
    this.modalService.close();
  }

  validateTimeRange(): boolean {
    if (!this.form.controls.diaInteiro.value) {
      const horaInicio = this.form.controls.horaInicio.value;
      const horaFim = this.form.controls.horaFim.value;

      if (!horaInicio || !horaFim) {
        this.toast.notify({
          message: 'Hora de início e fim são obrigatórias para eventos com horário específico.',
          type: 'ERROR',
        });
        return false;
      }

      if (horaInicio >= horaFim) {
        this.toast.notify({
          message: 'Hora de fim deve ser posterior à hora de início.',
          type: 'ERROR',
        });
        return false;
      }
    }
    return true;
  }

  validateTurmas(): boolean {
    const enviarPara = this.form.controls.enviarPara.value;
    const enviarTodasTurmas = this.form.controls.enviarTodasTurmas.value;
    const idsTurmas = this.form.controls.idsTurmas.value;

    if (enviarPara === 'Pais' && !enviarTodasTurmas) {
      if (!idsTurmas || idsTurmas.length === 0) {
        this.toast.notify({
          message: 'Selecione pelo menos uma turma ou marque "Todas".',
          type: 'ERROR',
        });
        return false;
      }
    }
    return true;
  }
}
